<script>
    import { createEventDispatcher } from "svelte";
    export let open = true;

    const dispatch = createEventDispatcher();

    const handleClose = () => {
        dispatch('close');
        open = false;
    }
</script>

{#if open}
    <div class="modal">
        <div class="blur" on:click={handleClose}>
            <slot></slot>
        </div>
    </div>
{/if}

<style>
    .modal {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        right: 0;
        z-index: 20;
    }
    .blur {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.2);
    }
</style>
